import React from 'react';
import { Box, Text } from '@primer/react';
import { Link } from 'react-router-dom';

const SiteMap = () => {
    return (
        <Box
            sx={{
                display: 'none', // Hidden from users, visible to crawlers
                fontSize: 0,
                position: 'absolute',
                left: '-9999px'
            }}
        >
            <nav aria-label="Site navigation for search engines">
                <Text as="h2">Site Navigation</Text>
                <ul>
                    <li><Link to="/">About Dylan Cattelan - Software Engineer</Link></li>
                    <li><Link to="/timeline">Professional Experience Timeline</Link></li>
                    <li><Link to="/projects">Software Engineering Projects</Link></li>
                    <li><Link to="/learn-dsa">Learn DSA - Interactive Learning Platform</Link></li>
                    <li><Link to="/changelog">Website Development Changelog</Link></li>
                </ul>
                
                <Text as="h3">Key Topics</Text>
                <ul>
                    <li>Backend Development</li>
                    <li>System Design</li>
                    <li>Data Structures</li>
                    <li>Algorithms</li>
                    <li>Software Engineering</li>
                    <li>Montreal Software Developer</li>
                    <li>Remote Work Experience</li>
                    <li>Website Development History</li>
                    <li>Technical Changelog</li>
                    <li>Programming Learning Platform</li>
                    <li>Interactive Learning Tools</li>
                </ul>
            </nav>
        </Box>
    );
};

export default SiteMap; 